import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable, ReplaySubject, tap } from 'rxjs';
import { User } from 'app/core/user/user.types';
import { Navigation_Service } from '../navigation/navigation.service';

@Injectable({
    providedIn: 'root'
})
export class User_Service {
    public current: User;
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient
    ) {
        this._user.subscribe(user => { this.current = user; });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User) {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current logged in user data
     */
    get(): Observable<User> {
        const token = localStorage.getItem('access_token');
        const headers = new HttpHeaders().set('Authorization', token || '');
        return this._httpClient.post<User>('api/session/refresh-access-token', {}, { headers })
            .pipe(
                tap((response: any) => {
                    this._user.next(response.payload);
                })
            );
    }
}
